
import { docsRegistry, DocEntry } from '../data/docs-registry';
import { Language } from '@/types';

/**
 * Enterprise Search Engine for Nova Documentation
 * Implements weighted matching based on Title, Description, and Keywords
 */
export const searchDocs = (query: string, lang: Language): DocEntry[] => {
  const normalizedQuery = query.trim().toLowerCase();
  
  if (!normalizedQuery) return [];

  return docsRegistry
    .map(entry => {
      let score = 0;
      const title = entry.title[lang].toLowerCase();
      const desc = entry.description[lang].toLowerCase();
      const keywords = entry.keywords.map(k => k.toLowerCase());

      // Priority 1: Exact match or start of title (Highest Weight)
      if (title === normalizedQuery) score += 200;
      if (title.startsWith(normalizedQuery)) score += 100;
      if (title.includes(normalizedQuery)) score += 50;

      // Priority 2: Keyword matches (Fuzzy & Multi-directional)
      keywords.forEach(k => {
        // Query is in keyword (e.g., 'arc' in 'arcpy')
        if (k.includes(normalizedQuery)) score += 40;
        // Keyword is in query (e.g., 'arcpy' in 'how to use arcpy')
        if (normalizedQuery.includes(k)) score += 30;
      });

      // Priority 3: Description matches
      if (desc.includes(normalizedQuery)) score += 20;

      return { entry, score };
    })
    .filter(result => result.score > 0)
    .sort((a, b) => b.score - a.score)
    .map(result => result.entry);
};
